export const LAYOUTS = {
  "Offline Program Tek Kişilik": {
    template: "offlinetemplate.png",
    persons: [
      { top: -40, left: 150, width: 1140, height: 1640, bgTop: -15, rankIcon: { top: 1400, left: 20, width: 232 } }
    ],
    texts: {
      baslik: { y: 450, size: 95 },
      altBaslik: { y: 540, size: 95 },
      names: [ { x: 720, y: 1880, size: 60, unvanY: 1950, unvanSize: 50 } ],
      adres: { x: 160, y: 2320, size: 35 },
      tarih: { x: 1195, y: 2320, size: 50 },
      saat: { x: 1260, y: 2320, size: 50 },
      gun: { x: 1195, y: 2400, size: 40 }
    }
  },
  "Offline Program 2 Kişilik": {
    template: "offlinetemplate.png",
    persons: [
      { top: 110, left: 0, width: 720, height: 1280, bgTop: 135, rankIcon: { top: 1040, left: 20, width: 162 } },
      { top: 110, left: 720, width: 720, height: 1280, bgTop: 135, rankIcon: { top: 1040, left: 700, width: 162 } }
    ],
    texts: {
      baslik: { y: 450, size: 95 },
      altBaslik: { y: 540, size: 95 },
      names: [
        { x: 360, y: 1500, size: 65, unvanY: 1590, unvanSize: 55 },
        { x: 1080, y: 1500, size: 65, unvanY: 1590, unvanSize: 55 }
      ],
      adres: { x: 160, y: 2320, size: 35 },
      tarih: { x: 1195, y: 2320, size: 50 },
      saat: { x: 1260, y: 2320, size: 50 },
      gun: { x: 1195, y: 2400, size: 40 }
    }
  },
  "Offline Program 3 Kişilik": {
    template: "offlinetemplate.png",
    persons: [
      { top: 50, left: 320, width: 800, height: 1100, bgTop: 65, rankIcon: { top: 970, left: 380, width: 170 } },
      { top: 770, left: 10, width: 750, height: 1100, bgTop: 785, rankIcon: { top: 1770, left: 65, width: 160 } },
      { top: 770, left: 680, width: 750, height: 1100, bgTop: 785, rankIcon: { top: 1770, left: 705, width: 160 } }
    ],
    texts: {
      baslik: { y: 450, size: 95 },
      altBaslik: { y: 540, size: 95 },
      names: [
        { x: 720, y: 1190, size: 65, unvanY: 1270, unvanSize: 50 },
        { x: 385, y: 1910, size: 60, unvanY: 1990, unvanSize: 45 },
        { x: 1055, y: 1910, size: 60, unvanY: 1990, unvanSize: 45 }
      ],
      adres: { x: 160, y: 2320, size: 35 },
      tarih: { x: 1195, y: 2320, size: 50 },
      saat: { x: 1260, y: 2320, size: 50 },
      gun: { x: 1195, y: 2400, size: 40 }
    }
  },
  "Offline Program 4 Kişilik": {
    template: "offlinetemplate.png",
    persons: [
      { top: 100, left: 10, width: 700, height: 1000, bgTop: 115, rankIcon: { top: 930, left: 75, width: 150 } },
      { top: 100, left: 730, width: 700, height: 1000, bgTop: 115, rankIcon: { top: 930, left: 715, width: 150 } },
      { top: 820, left: 10, width: 700, height: 1000, bgTop: 835, rankIcon: { top: 1730, left: 65, width: 150 } },
      { top: 820, left: 730, width: 700, height: 1000, bgTop: 835, rankIcon: { top: 1730, left: 705, width: 150 } }
    ],
    texts: {
      baslik: { y: 450, size: 95 },
      altBaslik: { y: 540, size: 95 },
      names: [
        { x: 360, y: 1140, size: 55, unvanY: 1220, unvanSize: 40 },
        { x: 1080, y: 1140, size: 55, unvanY: 1220, unvanSize: 40 }, 
        { x: 360, y: 1860, size: 55, unvanY: 1940, unvanSize: 40 },
        { x: 1080, y: 1860, size: 55, unvanY: 1940, unvanSize: 40 }
      ],
      adres: { x: 160, y: 2320, size: 35 },
      tarih: { x: 1195, y: 2320, size: 50 },
      saat: { x: 1260, y: 2320, size: 50 },
      gun: { x: 1195, y: 2400, size: 40 }
    }
  },
  "Offline Program 5 Kişilik": {
    template: "offlinetemplate.png",
    persons: [
      { top: 245, left: 50, width: 650, height: 850, bgTop: 250, rankIcon: { top: 995, left: 100, width: 150 } },
      { top: 245, left: 740, width: 650, height: 850, bgTop: 250, rankIcon: { top: 995, left: 720, width: 150 } },
      { top: 895, left: 20, width: 460, height: 800, bgTop: 900, rankIcon: { top: 1795, left: -40, width: 130 } },
      { top: 895, left: 490, width: 460, height: 800, bgTop: 900, rankIcon: { top: 1795, left: 420, width: 130 } },
      { top: 895, left: 960, width: 460, height: 800, bgTop: 900, rankIcon: { top: 1795, left: 880, width: 130 } }
    ],
    texts: {
      baslik: { y: 450, size: 95 },
      altBaslik: { y: 540, size: 95 },
      names: [
        { x: 375, y: 1140, size: 50, unvanY: 1205, unvanSize: 40 },
        { x: 1065, y: 1140, size: 50, unvanY: 1205, unvanSize: 40 },
        { x: 250, y: 1740, size: 48, unvanY: 1805, unvanSize: 38 },
        { x: 720, y: 1740, size: 48, unvanY: 1805, unvanSize: 38 },
        { x: 1190, y: 1740, size: 48, unvanY: 1805, unvanSize: 38 }
      ],
      adres: { x: 160, y: 2320, size: 35 },
      tarih: { x: 1195, y: 2320, size: 50 },
      saat: { x: 1260, y: 2320, size: 50 },
      gun: { x: 1195, y: 2400, size: 40 }
    }
  },
  "Offline Program 6 Kişilik": {
    template: "offlinetemplate.png",
    persons: [
      { top: 300, left: 0, width: 550, height: 750, bgTop: 300, rankIcon: { top: 1000, left: 10, width: 118 } },
      { top: 300, left: 445, width: 550, height: 750, bgTop: 300, rankIcon: { top: 1000, left: 430, width: 118 } },
      { top: 300, left: 890, width: 550, height: 750, bgTop: 300, rankIcon: { top: 1000, left: 850, width: 118 } },
      { top: 950, left: 0, width: 550, height: 750, bgTop: 950, rankIcon: { top: 1800, left: 10, width: 118 } },
      { top: 950, left: 445, width: 550, height: 750, bgTop: 950, rankIcon: { top: 1800, left: 430, width: 118 } },
      { top: 950, left: 890, width: 550, height: 750, bgTop: 950, rankIcon: { top: 1800, left: 850, width: 118 } }
    ],
    texts: {
      baslik: { y: 450, size: 95 },
      altBaslik: { y: 540, size: 95 },
      names: [
        { x: 275, y: 1090, size: 45, unvanY: 1150, unvanSize: 35 },
        { x: 720, y: 1090, size: 45, unvanY: 1150, unvanSize: 35 },
        { x: 1165, y: 1090, size: 45, unvanY: 1150, unvanSize: 35 },
        { x: 275, y: 1740, size: 45, unvanY: 1800, unvanSize: 35 },
        { x: 720, y: 1740, size: 45, unvanY: 1800, unvanSize: 35 },
        { x: 1165, y: 1740, size: 45, unvanY: 1800, unvanSize: 35 }
      ],
      adres: { x: 160, y: 2320, size: 35 },
      tarih: { x: 1195, y: 2320, size: 50 },
      saat: { x: 1260, y: 2320, size: 50 },
      gun: { x: 1195, y: 2400, size: 40 }
    }
  },
  "Offline Program 8 Kişilik": {
    template: "offlinetemplate.png",
    persons: [
      { top: 280, left: 0, width: 480, height: 600, rankIcon: { top: 650, left: -10, width: 130 } },
      { top: 280, left: 480, width: 480, height: 600, rankIcon: { top: 650, left: 470, width: 130 } },
      { top: 280, left: 960, width: 480, height: 600, rankIcon: { top: 650, left: 950, width: 130 } },
      { top: 880, left: 0, width: 480, height: 600, rankIcon: { top: 1250, left: -10, width: 130 } },
      { top: 880, left: 480, width: 480, height: 600, rankIcon: { top: 1250, left: 470, width: 130 } },
      { top: 880, left: 960, width: 480, height: 600, rankIcon: { top: 1250, left: 950, width: 130 } },
      { top: 1480, left: 240, width: 480, height: 600, rankIcon: { top: 1850, left: 230, width: 130 } },
      { top: 1480, left: 720, width: 480, height: 600, rankIcon: { top: 1850, left: 710, width: 130 } }
    ],
    texts: {
      baslik: { y: 390, size: 85 },
      altBaslik: { y: 490, size: 85 },
      names: [
        { x: 240, y: 940, size: 35, unvanY: 990, unvanSize: 30 },
        { x: 720, y: 940, size: 35, unvanY: 990, unvanSize: 30 },
        { x: 1200, y: 940, size: 35, unvanY: 990, unvanSize: 30 },
        { x: 240, y: 1540, size: 35, unvanY: 1590, unvanSize: 30 },
        { x: 720, y: 1540, size: 35, unvanY: 1590, unvanSize: 30 },
        { x: 1200, y: 1540, size: 35, unvanY: 1590, unvanSize: 30 },
        { x: 480, y: 2140, size: 35, unvanY: 2190, unvanSize: 30 },
        { x: 960, y: 2140, size: 35, unvanY: 2190, unvanSize: 30 }
      ],
      adres: { x: 160, y: 2320, size: 35 },
      tarih: { x: 1195, y: 2320, size: 50 },
      saat: { x: 1260, y: 2320, size: 50 },
      gun: { x: 1195, y: 2400, size: 40 } 
    }
  },
  "Offline Program 9 Kişilik": {
    template: "offlinetemplate.png",
    persons: [
      { top: 300, left: 0, width: 520, height: 650, bgTop: 300, rankIcon: { top: 750, left: -10, width: 113 } },
      { top: 300, left: 460, width: 520, height: 650, bgTop: 300, rankIcon: { top: 750, left: 470, width: 113 } },
      { top: 300, left: 920, width: 520, height: 650, bgTop: 300, rankIcon: { top: 750, left: 950, width: 113 } },
      { top: 840, left: 0, width: 520, height: 650, bgTop: 840, rankIcon: { top: 1350, left: -10, width: 113 } },
      { top: 840, left: 460, width: 520, height: 650, bgTop: 840, rankIcon: { top: 1350, left: 470, width: 113 } },
      { top: 840, left: 920, width: 520, height: 650, bgTop: 840, rankIcon: { top: 1350, left: 950, width: 113 } },
      { top: 1380, left: 0, width: 520, height: 650, bgTop: 1380, rankIcon: { top: 1950, left: -10, width: 113 } },
      { top: 1380, left: 460, width: 520, height: 650, bgTop: 1380, rankIcon: { top: 1950, left: 470, width: 113 } },
      { top: 1380, left: 920, width: 520, height: 650, bgTop: 1380, rankIcon: { top: 1950, left: 470, width: 113 } }
    ],
    texts: {
      baslik: { y: 450, size: 95 },
      altBaslik: { y: 540, size: 95 },
      names: [
        { x: 260, y: 990, size: 40, unvanY: 1045, unvanSize: 32 },
        { x: 720, y: 990, size: 40, unvanY: 1045, unvanSize: 32 },
        { x: 1180, y: 990, size: 40, unvanY: 1045, unvanSize: 32 },
        { x: 260, y: 1530, size: 40, unvanY: 1585, unvanSize: 32 },
        { x: 720, y: 1530, size: 40, unvanY: 1585, unvanSize: 32 },
        { x: 1180, y: 1530, size: 40, unvanY: 1585, unvanSize: 32 },
        { x: 260, y: 2070, size: 40, unvanY: 2125, unvanSize: 32 },
        { x: 720, y: 2070, size: 40, unvanY: 2125, unvanSize: 32 },
        { x: 1180, y: 2070, size: 40, unvanY: 2125, unvanSize: 32 }
      ],
      adres: { x: 160, y: 2320, size: 35 },
      tarih: { x: 1195, y: 2320, size: 50 },
      saat: { x: 1260, y: 2320, size: 50 },
      gun: { x: 1195, y: 2400, size: 40 }
    }
  },
  "Offline Program 12 Kişilik": {
    template: "offlinetemplate.png",
    persons: [
      { top: 440, left: 50, width: 320, height: 420, rankIcon: { top: 705, left: 40, width: 80 } },
      { top: 440, left: 390, width: 320, height: 420, rankIcon: { top: 705, left: 380, width: 80 } },
      { top: 440, left: 730, width: 320, height: 420, rankIcon: { top: 705, left: 740, width: 80 } },
      { top: 440, left: 1070, width: 320, height: 420, rankIcon: { top: 705, left: 1080, width: 80 } },
      { top: 970, left: 50, width: 320, height: 420, rankIcon: { top: 1220, left: 55, width: 80 } },
      { top: 970, left: 390, width: 320, height: 420, rankIcon: { top: 1220, left: 395, width: 80 } },
      { top: 970, left: 730, width: 320, height: 420, rankIcon: { top: 1220, left: 735, width: 80 } },
      { top: 970, left: 1070, width: 320, height: 420, rankIcon: { top: 1220, left: 1075, width: 80 } },
      { top: 1500, left: 50, width: 320, height: 420, rankIcon: { top: 1790, left: 20, width: 80 } },
      { top: 1500, left: 390, width: 320, height: 420, rankIcon: { top: 1790, left: 360, width: 80 } },
      { top: 1500, left: 730, width: 320, height: 420, rankIcon: { top: 1790, left: 700, width: 80 } },
      { top: 1500, left: 1070, width: 320, height: 420, rankIcon: { top: 1790, left: 1040, width: 80 } }
    ],
    texts: {
      baslik: { y: 380, size: 80 },
      altBaslik: { y: 460, size: 60 },
      names: [
        { x: 210, y: 920, size: 32, unvanY: 970, unvanSize: 26 },
        { x: 550, y: 920, size: 32, unvanY: 970, unvanSize: 26 },
        { x: 890, y: 920, size: 32, unvanY: 970, unvanSize: 26 },
        { x: 1230, y: 920, size: 32, unvanY: 970, unvanSize: 26 },
        { x: 210, y: 1450, size: 32, unvanY: 1500, unvanSize: 26 },
        { x: 550, y: 1450, size: 32, unvanY: 1500, unvanSize: 26 },
        { x: 890, y: 1450, size: 32, unvanY: 1500, unvanSize: 26 },
        { x: 1230, y: 1450, size: 32, unvanY: 1500, unvanSize: 26 },
        { x: 210, y: 1980, size: 32, unvanY: 2030, unvanSize: 26 },
        { x: 550, y: 1980, size: 32, unvanY: 2030, unvanSize: 26 },
        { x: 890, y: 1980, size: 32, unvanY: 2030, unvanSize: 26 },
        { x: 1230, y: 1980, size: 32, unvanY: 2030, unvanSize: 26 }
      ],
      adres: { x: 160, y: 2320, size: 35 },
      tarih: { x: 1195, y: 2320, size: 50 },
      saat: { x: 1260, y: 2320, size: 50 },
      gun: { x: 1195, y: 2400, size: 40 }
    }
  },
  "Offline Program 16 Kişilik": {
    template: "offlinetemplate.png",
    persons: [
      { top: 440, left: 55, width: 310, height: 400, rankIcon: { top: 780, left: 10, width: 80 } },
      { top: 440, left: 395, width: 310, height: 400, rankIcon: { top: 780, left: 350, width: 80 } },
      { top: 440, left: 735, width: 310, height: 400, rankIcon: { top: 780, left: 710, width: 80 } },
      { top: 440, left: 1075, width: 310, height: 400, rankIcon: { top: 780, left: 1050, width: 80 } },
      { top: 860, left: 55, width: 310, height: 400, rankIcon: { top: 1200, left: 10, width: 80 } },
      { top: 860, left: 395, width: 310, height: 400, rankIcon: { top: 1200, left: 350, width: 80 } },
      { top: 860, left: 735, width: 310, height: 400, rankIcon: { top: 1200, left: 710, width: 80 } },
      { top: 860, left: 1075, width: 310, height: 400, rankIcon: { top: 1200, left: 1050, width: 80 } },
      { top: 1280, left: 55, width: 310, height: 400, rankIcon: { top: 1620, left: 10, width: 80 } },
      { top: 1280, left: 395, width: 310, height: 400, rankIcon: { top: 1620, left: 350, width: 80 } },
      { top: 1280, left: 735, width: 310, height: 400, rankIcon: { top: 1620, left: 710, width: 80 } },
      { top: 1280, left: 1075, width: 310, height: 400, rankIcon: { top: 1620, left: 1050, width: 80 } },
      { top: 1700, left: 55, width: 310, height: 400, rankIcon: { top: 2040, left: 10, width: 80 } },
      { top: 1700, left: 395, width: 310, height: 400, rankIcon: { top: 2040, left: 350, width: 80 } },
      { top: 1700, left: 735, width: 310, height: 400, rankIcon: { top: 2040, left: 710, width: 80 } },
      { top: 1700, left: 1075, width: 310, height: 400, rankIcon: { top: 2040, left: 1050, width: 80 } }
    ],
    texts: {
      baslik: { y: 380, size: 80 },
      altBaslik: { y: 460, size: 60 },
      names: [
        { x: 210, y: 880, size: 30, unvanY: 920, unvanSize: 25 },
        { x: 550, y: 880, size: 30, unvanY: 920, unvanSize: 25 },
        { x: 890, y: 880, size: 30, unvanY: 920, unvanSize: 25 },
        { x: 1230, y: 880, size: 30, unvanY: 920, unvanSize: 25 },
        { x: 210, y: 1300, size: 30, unvanY: 1340, unvanSize: 25 },
        { x: 550, y: 1300, size: 30, unvanY: 1340, unvanSize: 25 },
        { x: 890, y: 1300, size: 30, unvanY: 1340, unvanSize: 25 },
        { x: 1230, y: 1300, size: 30, unvanY: 1340, unvanSize: 25 },
        { x: 210, y: 1720, size: 30, unvanY: 1760, unvanSize: 25 },
        { x: 550, y: 1720, size: 30, unvanY: 1760, unvanSize: 25 },
        { x: 890, y: 1720, size: 30, unvanY: 1760, unvanSize: 25 },
        { x: 1230, y: 1720, size: 30, unvanY: 1760, unvanSize: 25 },
        { x: 210, y: 2140, size: 30, unvanY: 2180, unvanSize: 25 },
        { x: 550, y: 2140, size: 30, unvanY: 2180, unvanSize: 25 },
        { x: 890, y: 2140, size: 30, unvanY: 2180, unvanSize: 25 },
        { x: 1230, y: 2140, size: 30, unvanY: 2180, unvanSize: 25 }
      ],
      adres: { x: 160, y: 2320, size: 35 },
      tarih: { x: 1195, y: 2320, size: 50 },
      saat: { x: 1260, y: 2320, size: 50 },
      gun: { x: 1195, y: 2400, size: 40 }
    }
  },
  "Online Program Tek Kişilik": {
    template: "2026_online_template.png",
    persons: [
      { top: 60, left: 150, width: 1140, height: 1640, bgTop: 80, rankIcon: { top: 1349, left: 20, width: 232 } }
    ],
    texts: {
      baslik: { y: 450, size: 95 },
      altBaslik: { y: 360, size: 95 },
      egitimKonusu: { x: 75, y: 2250, size: 50, labelY: 2190 },
      names: [ { x: 720, y: 1819, size: 85, unvanY: 1919, unvanSize: 65 } ],
      tarih: { x: 1195, y: 2345, size: 50 },
      saat: { x: 1250, y: 2345, size: 50 },
      gun: { x: 1165, y: 2390, size: 38 }
    }
  },
  "Online Program 2 Kişilik": {
    template: "2026_online_template.png",
    persons: [
      { top: 110, left: 0, width: 720, height: 1280, bgTop: 135, rankIcon: { top: 1040, left: 20, width: 162 } },
      { top: 110, left: 720, width: 720, height: 1280, bgTop: 135, rankIcon: { top: 1040, left: 700, width: 162 } }
    ],
    texts: {
      baslik: { y: 450, size: 95 },
      altBaslik: { y: 360, size: 95 },
      egitimKonusu: { x: 75, y: 2180, size: 50, labelY: 2120 },
      names: [
        { x: 360, y: 1500, size: 65, unvanY: 1590, unvanSize: 55 },
        { x: 1080, y: 1500, size: 65, unvanY: 1590, unvanSize: 55 }
      ],
      tarih: { x: 1195, y: 2345, size: 50 },
      saat: { x: 1250, y: 2345, size: 50 },
      gun: { x: 1165, y: 2390, size: 38 }
    }
  },
  "Online Program 3 Kişilik": {
    template: "2026_online_template.png",
    persons: [
      { top: 180, left: 345, width: 750, height: 1000, bgTop: 195, rankIcon: { top: 855, left: 380, width: 160 } },
      { top: 900, left: 15, width: 700, height: 1000, bgTop: 915, rankIcon: { top: 1655, left: 65, width: 150 } },
      { top: 900, left: 725, width: 700, height: 1000, bgTop: 915, rankIcon: { top: 1655, left: 705, width: 150 } }
    ],
    texts: {
      baslik: { y: 450, size: 95 },
      altBaslik: { y: 360, size: 95 },
      egitimKonusu: { x: 75, y: 2250, size: 50, labelY: 2190 },
      names: [
        { x: 720, y: 1220, size: 60, unvanY: 1300, unvanSize: 45 },
        { x: 365, y: 1940, size: 55, unvanY: 2020, unvanSize: 40 },
        { x: 1075, y: 1940, size: 55, unvanY: 2020, unvanSize: 40 }
      ],
      tarih: { x: 1195, y: 2345, size: 50 },
      saat: { x: 1260, y: 2345, size: 50 },
      gun: { x: 1165, y: 2420, size: 38 }
    }
  },
  "Online Program 4 Kişilik": {
    template: "2026_online_template.png",
    persons: [
      { top: 100, left: 10, width: 700, height: 1000, bgTop: 115, rankIcon: { top: 875, left: 75, width: 150 } },
      { top: 100, left: 730, width: 700, height: 1000, bgTop: 115, rankIcon: { top: 875, left: 715, width: 150 } },
      { top: 820, left: 10, width: 700, height: 1000, bgTop: 835, rankIcon: { top: 1675, left: 65, width: 150 } },
      { top: 820, left: 730, width: 700, height: 1000, bgTop: 835, rankIcon: { top: 1675, left: 705, width: 150 } }
    ],
    texts: {
      baslik: { y: 450, size: 95 },
      altBaslik: { y: 360, size: 95 },
      egitimKonusu: { x: 75, y: 2250, size: 50, labelY: 2190 },
      names: [
        { x: 360, y: 1140, size: 55, unvanY: 1220, unvanSize: 40 },
        { x: 1080, y: 1140, size: 55, unvanY: 1220, unvanSize: 40 }, 
        { x: 360, y: 1860, size: 55, unvanY: 1940, unvanSize: 40 },
        { x: 1080, y: 1860, size: 55, unvanY: 1940, unvanSize: 40 }
      ],
      tarih: { x: 1195, y: 2345, size: 50 },
      saat: { x: 1260, y: 2345, size: 50 },
      gun: { x: 1165, y: 2420, size: 38 }
    }
  },
  "Online Program 5 Kişilik": {
    template: "2026_online_template.png",
    persons: [
      { top: 190, left: 50, width: 650, height: 850, bgTop: 190, rankIcon: { top: 870, left: 100, width: 150 } },
      { top: 190, left: 740, width: 650, height: 850, bgTop: 190, rankIcon: { top: 870, left: 720, width: 150 } },
      { top: 840, left: 20, width: 460, height: 800, bgTop: 840, rankIcon: { top: 1610, left: -40, width: 130 } },
      { top: 840, left: 490, width: 460, height: 800, bgTop: 840, rankIcon: { top: 1610, left: 420, width: 130 } },
      { top: 840, left: 960, width: 460, height: 800, bgTop: 840, rankIcon: { top: 1610, left: 880, width: 130 } }
    ],
    texts: {
      baslik: { y: 430, size: 80 },
      altBaslik: { y: 350, size: 80 },
      egitimKonusu: { x: 75, y: 2250, size: 50, labelY: 2190 },
      names: [
        { x: 375, y: 1080, size: 50, unvanY: 1145, unvanSize: 40 },
        { x: 1065, y: 1080, size: 50, unvanY: 1145, unvanSize: 40 },
        { x: 250, y: 1680, size: 48, unvanY: 1745, unvanSize: 38 },
        { x: 720, y: 1680, size: 48, unvanY: 1745, unvanSize: 38 },
        { x: 1190, y: 1680, size: 48, unvanY: 1745, unvanSize: 38 }
      ],
      tarih: { x: 1195, y: 2290, size: 55 },
      saat: { x: 1260, y: 2290, size: 55 },
      gun: { x: 1165, y: 2370, size: 45 }
    }
  },
  "Online Program 6 Kişilik": {
    template: "2026_online_template.png",
    persons: [
      { top: 300, left: 0, width: 550, height: 750, bgTop: 300, rankIcon: { top: 1000, left: 10, width: 118 } },
      { top: 300, left: 445, width: 550, height: 750, bgTop: 300, rankIcon: { top: 1000, left: 430, width: 118 } },
      { top: 300, left: 890, width: 550, height: 750, bgTop: 300, rankIcon: { top: 1000, left: 850, width: 118 } },
      { top: 950, left: 0, width: 550, height: 750, bgTop: 950, rankIcon: { top: 1800, left: 10, width: 118 } },
      { top: 950, left: 445, width: 550, height: 750, bgTop: 950, rankIcon: { top: 1800, left: 430, width: 118 } },
      { top: 950, left: 890, width: 550, height: 750, bgTop: 950, rankIcon: { top: 1800, left: 850, width: 118 } }
    ],
    texts: {
      baslik: { y: 560, size: 80 },
      altBaslik: { y: 480, size: 80 },
      egitimKonusu: { x: 75, y: 2250, size: 50, labelY: 2190 },
      names: [
        { x: 275, y: 1090, size: 45, unvanY: 1150, unvanSize: 35 },
        { x: 720, y: 1090, size: 45, unvanY: 1150, unvanSize: 35 },
        { x: 1165, y: 1090, size: 45, unvanY: 1150, unvanSize: 35 },
        { x: 275, y: 1740, size: 45, unvanY: 1800, unvanSize: 35 },
        { x: 720, y: 1740, size: 45, unvanY: 1800, unvanSize: 35 },
        { x: 1165, y: 1740, size: 45, unvanY: 1800, unvanSize: 35 }
      ],
      tarih: { x: 1195, y: 2345, size: 50 },
      saat: { x: 1260, y: 2345, size: 50 },
      gun: { x: 1165, y: 2420, size: 38 }
    }
  },
  "Online Program 8 Kişilik": {
    template: "2026_online_template.png",
    persons: [
      { top: 250, left: 0, width: 480, height: 600, rankIcon: { top: 750, left: -10, width: 130 } },
      { top: 250, left: 480, width: 480, height: 600, rankIcon: { top: 750, left: 470, width: 130 } },
      { top: 250, left: 960, width: 480, height: 600, rankIcon: { top: 750, left: 950, width: 130 } },
      { top: 850, left: 0, width: 480, height: 600, rankIcon: { top: 1350, left: -10, width: 130 } },
      { top: 850, left: 480, width: 480, height: 600, rankIcon: { top: 1350, left: 470, width: 130 } },
      { top: 850, left: 960, width: 480, height: 600, rankIcon: { top: 1350, left: 950, width: 130 } },
      { top: 1450, left: 240, width: 480, height: 600, rankIcon: { top: 1950, left: 230, width: 130 } },
      { top: 1450, left: 720, width: 480, height: 600, rankIcon: { top: 1950, left: 710, width: 130 } }
    ],
    texts: {
      baslik: { y: 400, size: 95 },
      altBaslik: { y: 320, size: 95 },
      egitimKonusu: { x: 75, y: 2280, size: 50, labelY: 2220 },
      names: [
        { x: 240, y: 900, size: 38, unvanY: 955, unvanSize: 32 },
        { x: 720, y: 900, size: 38, unvanY: 955, unvanSize: 32 },
        { x: 1200, y: 900, size: 38, unvanY: 955, unvanSize: 32 },
        { x: 240, y: 1500, size: 38, unvanY: 1555, unvanSize: 32 },
        { x: 720, y: 1500, size: 38, unvanY: 1555, unvanSize: 32 },
        { x: 1200, y: 1500, size: 38, unvanY: 1555, unvanSize: 32 },
        { x: 480, y: 2100, size: 38, unvanY: 2155, unvanSize: 32 },
        { x: 960, y: 2100, size: 38, unvanY: 2155, unvanSize: 32 }
      ],
      tarih: { x: 1195, y: 2330, size: 55 },
      saat: { x: 1260, y: 2330, size: 55 },
      gun: { x: 1165, y: 2410, size: 45 }
    }
  },
  "Online Program 9 Kişilik": {
    template: "2026_online_template.png",
    persons: [
      { top: 260, left: 0, width: 480, height: 575, bgTop: 260, rankIcon: { top: 750, left: -10, width: 113 } },
      { top: 260, left: 480, width: 480, height: 575, bgTop: 260, rankIcon: { top: 750, left: 470, width: 113 } },
      { top: 260, left: 960, width: 480, height: 575, bgTop: 260, rankIcon: { top: 750, left: 950, width: 113 } },
      { top: 860, left: 0, width: 480, height: 575, bgTop: 860, rankIcon: { top: 1350, left: -10, width: 113 } },
      { top: 860, left: 480, width: 480, height: 575, bgTop: 860, rankIcon: { top: 1350, left: 470, width: 113 } },
      { top: 860, left: 960, width: 480, height: 575, bgTop: 860, rankIcon: { top: 1350, left: 950, width: 113 } },
      { top: 1460, left: 0, width: 480, height: 575, bgTop: 1460, rankIcon: { top: 1950, left: -10, width: 113 } },
      { top: 1460, left: 480, width: 480, height: 575, bgTop: 1460, rankIcon: { top: 1950, left: 470, width: 113 } },
      { top: 1460, left: 960, width: 480, height: 575, bgTop: 1460, rankIcon: { top: 1950, left: 950, width: 113 } }
    ],
    texts: {
      baslik: { y: 430, size: 85 },
      altBaslik: { y: 350, size: 85 },
      egitimKonusu: { x: 75, y: 2290, size: 50, labelY: 2230 },
      names: [
        { x: 240, y: 880, size: 35, unvanY: 935, unvanSize: 28 },
        { x: 720, y: 880, size: 35, unvanY: 935, unvanSize: 28 },
        { x: 1200, y: 880, size: 35, unvanY: 935, unvanSize: 28 },
        { x: 240, y: 1480, size: 35, unvanY: 1535, unvanSize: 28 },
        { x: 720, y: 1480, size: 35, unvanY: 1535, unvanSize: 28 },
        { x: 1200, y: 1480, size: 35, unvanY: 1535, unvanSize: 28 },
        { x: 240, y: 2080, size: 35, unvanY: 2135, unvanSize: 28 },
        { x: 720, y: 2080, size: 35, unvanY: 2135, unvanSize: 28 },
        { x: 1200, y: 2080, size: 35, unvanY: 2135, unvanSize: 28 }
      ],
      tarih: { x: 1195, y: 2330, size: 50 },
      saat: { x: 1260, y: 2330, size: 50 },
      gun: { x: 1165, y: 2410, size: 40 }
    }
  },
  "Online Program 12 Kişilik": {
    template: "2026_online_template.png",
    persons: [
      { top: 300, left: 0, width: 360, height: 520, bgTop: 300, rankIcon: { top: 720, left: -20, width: 99 } },
      { top: 300, left: 360, width: 360, height: 520, bgTop: 300, rankIcon: { top: 720, left: 340, width: 99 } },
      { top: 300, left: 720, width: 360, height: 520, bgTop: 300, rankIcon: { top: 720, left: 700, width: 99 } },
      { top: 300, left: 1080, width: 360, height: 520, bgTop: 300, rankIcon: { top: 720, left: 1060, width: 99 } },
      { top: 850, left: 0, width: 360, height: 520, bgTop: 850, rankIcon: { top: 1270, left: -20, width: 99 } },
      { top: 850, left: 360, width: 360, height: 520, bgTop: 850, rankIcon: { top: 1270, left: 340, width: 99 } },
      { top: 850, left: 720, width: 360, height: 520, bgTop: 850, rankIcon: { top: 1270, left: 700, width: 99 } },
      { top: 850, left: 1080, width: 360, height: 520, bgTop: 850, rankIcon: { top: 1270, left: 1060, width: 99 } },
      { top: 1400, left: 0, width: 360, height: 520, bgTop: 1400, rankIcon: { top: 1820, left: -20, width: 99 } },
      { top: 1400, left: 360, width: 360, height: 520, bgTop: 1400, rankIcon: { top: 1820, left: 340, width: 99 } },
      { top: 1400, left: 720, width: 360, height: 520, bgTop: 1400, rankIcon: { top: 1820, left: 700, width: 99 } },
      { top: 1400, left: 1080, width: 360, height: 520, bgTop: 1400, rankIcon: { top: 1820, left: 1060, width: 99 } }
    ],
    texts: {
      baslik: { y: 450, size: 95 },
      altBaslik: { y: 360, size: 95 },
      egitimKonusu: { x: 75, y: 2250, size: 50, labelY: 2190 },
      names: [
        { x: 180, y: 850, size: 36, unvanY: 905, unvanSize: 30 },
        { x: 540, y: 850, size: 36, unvanY: 905, unvanSize: 30 },
        { x: 900, y: 850, size: 36, unvanY: 905, unvanSize: 30 },
        { x: 1260, y: 850, size: 36, unvanY: 905, unvanSize: 30 },
        { x: 180, y: 1400, size: 36, unvanY: 1455, unvanSize: 30 },
        { x: 540, y: 1400, size: 36, unvanY: 1455, unvanSize: 30 },
        { x: 900, y: 1400, size: 36, unvanY: 1455, unvanSize: 30 },
        { x: 1260, y: 1400, size: 36, unvanY: 1455, unvanSize: 30 },
        { x: 180, y: 1950, size: 36, unvanY: 2005, unvanSize: 30 },
        { x: 540, y: 1950, size: 36, unvanY: 2005, unvanSize: 30 },
        { x: 900, y: 1950, size: 36, unvanY: 2005, unvanSize: 30 },
        { x: 1260, y: 1950, size: 36, unvanY: 2005, unvanSize: 30 }
      ],
      tarih: { x: 1195, y: 2345, size: 50 },
      saat: { x: 1260, y: 2345, size: 50 },
      gun: { x: 1165, y: 2420, size: 38 }
    }
  },
  "Online Program 16 Kişilik": {
    template: "2026_online_template.png",
    persons: [
      { top: 340, left: 55, width: 310, height: 400, bgTop: 335, rankIcon: { top: 680, left: 10, width: 72 } },
      { top: 340, left: 395, width: 310, height: 400, bgTop: 335, rankIcon: { top: 680, left: 350, width: 72 } },
      { top: 340, left: 735, width: 310, height: 400, bgTop: 335, rankIcon: { top: 710, left: 710, width: 72 } },
      { top: 340, left: 1075, width: 310, height: 400, bgTop: 335, rankIcon: { top: 680, left: 1050, width: 72 } },
      { top: 780, left: 55, width: 310, height: 400, bgTop: 775, rankIcon: { top: 1120, left: 10, width: 72 } },
      { top: 780, left: 395, width: 310, height: 400, bgTop: 775, rankIcon: { top: 1120, left: 350, width: 72 } },
      { top: 780, left: 735, width: 310, height: 400, bgTop: 775, rankIcon: { top: 1120, left: 710, width: 72 } },
      { top: 780, left: 1075, width: 310, height: 400, bgTop: 775, rankIcon: { top: 1120, left: 1050, width: 72 } },
      { top: 1220, left: 55, width: 310, height: 400, bgTop: 1215, rankIcon: { top: 1570, left: 10, width: 72 } },
      { top: 1220, left: 395, width: 310, height: 400, bgTop: 1215, rankIcon: { top: 1570, left: 350, width: 72 } },
      { top: 1220, left: 735, width: 310, height: 400, bgTop: 1215, rankIcon: { top: 1570, left: 710, width: 72 } },
      { top: 1220, left: 1075, width: 310, height: 400, bgTop: 1215, rankIcon: { top: 1570, left: 1050, width: 72 } },
      { top: 1650, left: 55, width: 310, height: 400, bgTop: 1645, rankIcon: { top: 2000, left: 10, width: 72 } },
      { top: 1650, left: 395, width: 310, height: 400, bgTop: 1645, rankIcon: { top: 2000, left: 350, width: 72 } },
      { top: 1650, left: 735, width: 310, height: 400, bgTop: 1645, rankIcon: { top: 2000, left: 710, width: 72 } },
      { top: 1650, left: 1075, width: 310, height: 400, bgTop: 1645, rankIcon: { top: 2000, left: 1050, width: 72 } }
    ],
    texts: {
      baslik: { y: 380, size: 75 },
      altBaslik: { y: 310, size: 75 },
      egitimKonusu: { x: 75, y: 2320, size: 40, labelY: 2270 },
      names: [
        { x: 210, y: 770, size: 30, unvanY: 810, unvanSize: 25 },
        { x: 550, y: 770, size: 30, unvanY: 810, unvanSize: 25 },
        { x: 890, y: 770, size: 30, unvanY: 810, unvanSize: 25 },
        { x: 1230, y: 770, size: 30, unvanY: 810, unvanSize: 25 },
        { x: 210, y: 1210, size: 30, unvanY: 1250, unvanSize: 25 },
        { x: 550, y: 1210, size: 30, unvanY: 1250, unvanSize: 25 },
        { x: 890, y: 1210, size: 30, unvanY: 1250, unvanSize: 25 },
        { x: 1230, y: 1210, size: 30, unvanY: 1250, unvanSize: 25 },
        { x: 210, y: 1650, size: 30, unvanY: 1690, unvanSize: 25 },
        { x: 550, y: 1650, size: 30, unvanY: 1690, unvanSize: 25 },
        { x: 890, y: 1650, size: 30, unvanY: 1690, unvanSize: 25 },
        { x: 1230, y: 1650, size: 30, unvanY: 1690, unvanSize: 25 },
        { x: 210, y: 2080, size: 30, unvanY: 2120, unvanSize: 25 },
        { x: 550, y: 2080, size: 30, unvanY: 2120, unvanSize: 25 },
        { x: 890, y: 2080, size: 30, unvanY: 2120, unvanSize: 25 },
        { x: 1230, y: 2080, size: 30, unvanY: 2120, unvanSize: 25 }
      ],
      tarih: { x: 1195, y: 2345, size: 50 },
      saat: { x: 1260, y: 2345, size: 50 },
      gun: { x: 1200, y: 2420, size: 38 }
    }
  },
  "Kariyer Tebrik": {
    template: "Hoşgeldiniz Afişi.png",
    persons: [
      { top: 600, left: 320, width: 800, height: 1200, rankIcon: { top: 1840, left: 220, width: 250 } }
    ],
    texts: {
      baslik: { y: 375, size: 110 },
      altBaslik: { y: 480, size: 90 },
      names: [ { x: "50%", y: 2050, size: 90, unvanY: 2180, unvanSize: 80 } ],
      adres: { x: 140, y: 2400, size: 40 },
      tarih: { x: 1100, y: 2400, size: 50 },
      saat: { x: 1250, y: 2400, size: 50 },
      gun: { x: 1100, y: 2450, size: 40 }
    }
  },
  "6 Yıldız Kariyer Tebrik": {
    template: "6 Yıldızlı Kariyer Tebrik.png",
    persons: [
      { top: 320, left: 395, width: 650, height: 1100, rankIcon: { top: 1220, left: 495, width: 450 } }
    ],
    texts: {
      names: [ { x: 720, y: 2080, size: 90, unvanY: 0, unvanSize: 0 } ]
    }
  },
  "7 Yıldız Kariyer Tebrik": {
    template: "7 Yıldızlı Kariyer Tebrik.png",
    persons: [
      { top: 320, left: 395, width: 650, height: 1100, rankIcon: { top: 1220, left: 495, width: 450 } }
    ],
    texts: {
      names: [ { x: 720, y: 2080, size: 90, unvanY: 0, unvanSize: 0 } ]
    }
  },
  "8 Yıldız Kariyer Tebrik": {
    template: "8 Yıldızlı Kariyer Tebrik.png",
    persons: [
      { top: 320, left: 395, width: 650, height: 1100, rankIcon: { top: 1220, left: 495, width: 450 } }
    ],
    texts: {
      names: [ { x: 720, y: 2080, size: 90, unvanY: 0, unvanSize: 0 } ]
    }
  },
  "Günübirlik Akademi 9 Kişilik": {
    template: "Günübirlik Akademi.png",
    persons: [
      { top: 580, left: 100, width: 380, height: 390, rankIcon: { top: 840, left: 55, width: 120 } },
      { top: 580, left: 530, width: 380, height: 390, rankIcon: { top: 840, left: 485, width: 120 } },
      { top: 580, left: 960, width: 380, height: 390, rankIcon: { top: 840, left: 915, width: 120 } },
      { top: 1140, left: 100, width: 380, height: 390, rankIcon: { top: 1400, left: 55, width: 120 } },
      { top: 1140, left: 530, width: 380, height: 390, rankIcon: { top: 1400, left: 485, width: 120 } },
      { top: 1140, left: 960, width: 380, height: 390, rankIcon: { top: 1400, left: 915, width: 120 } },
      { top: 1700, left: 100, width: 380, height: 390, rankIcon: { top: 1960, left: 55, width: 120 } },
      { top: 1700, left: 530, width: 380, height: 390, rankIcon: { top: 1960, left: 485, width: 120 } },
      { top: 1700, left: 960, width: 380, height: 390, rankIcon: { top: 1960, left: 915, width: 120 } }
    ],
    texts: {
      baslik: { x: 960, y: 425, size: 70 },
      altBaslik: { x: 960, y: 495, size: 50 },
      names: [
        { x: 290, y: 1000, size: 40, unvanY: 1050, unvanSize: 30 },
        { x: 720, y: 1000, size: 40, unvanY: 1050, unvanSize: 30 },
        { x: 1150, y: 1000, size: 40, unvanY: 1050, unvanSize: 30 },
        { x: 290, y: 1560, size: 40, unvanY: 1610, unvanSize: 30 },
        { x: 720, y: 1560, size: 40, unvanY: 1610, unvanSize: 30 },
        { x: 1150, y: 1560, size: 40, unvanY: 1610, unvanSize: 30 },
        { x: 290, y: 2120, size: 40, unvanY: 2170, unvanSize: 30 },
        { x: 720, y: 2120, size: 40, unvanY: 2170, unvanSize: 30 },
        { x: 1150, y: 2120, size: 40, unvanY: 2170, unvanSize: 30 }
      ],
      adres: { x: 130, y: 2360, size: 32 },
      tarih: { x: 1140, y: 2360, size: 45 },
      saat: { x: 1190, y: 2430, size: 45 },
      gun: { x: 1170, y: 2450, size: 45 }
    }
  },
  "Günübirlik Akademi 12 Kişilik": {
    template: "Günübirlik Akademi.png",
    persons: [
      { top: 580, left: 50, width: 300, height: 360, rankIcon: { top: 872, left: 15, width: 100 } },
      { top: 580, left: 400, width: 300, height: 360, rankIcon: { top: 872, left: 365, width: 100 } },
      { top: 580, left: 750, width: 300, height: 360, rankIcon: { top: 872, left: 715, width: 100 } },
      { top: 580, left: 1100, width: 300, height: 360, rankIcon: { top: 872, left: 1065, width: 100 } },
      { top: 1080, left: 50, width: 300, height: 360, rankIcon: { top: 1372, left: 15, width: 100 } },
      { top: 1080, left: 400, width: 300, height: 360, rankIcon: { top: 1372, left: 365, width: 100 } },
      { top: 1080, left: 750, width: 300, height: 360, rankIcon: { top: 1372, left: 715, width: 100 } },
      { top: 1080, left: 1100, width: 300, height: 360, rankIcon: { top: 1372, left: 1065, width: 100 } },
      { top: 1580, left: 50, width: 300, height: 360, rankIcon: { top: 1872, left: 15, width: 100 } },
      { top: 1580, left: 400, width: 300, height: 360, rankIcon: { top: 1872, left: 365, width: 100 } },
      { top: 1580, left: 750, width: 300, height: 360, rankIcon: { top: 1872, left: 715, width: 100 } },
      { top: 1580, left: 1100, width: 300, height: 360, rankIcon: { top: 1872, left: 1065, width: 100 } }
    ],
    texts: {
      baslik: { x: 960, y: 425, size: 70 },
      altBaslik: { x: 960, y: 495, size: 50 },
      names: [
        { x: 200, y: 1000, size: 35, unvanY: 1045, unvanSize: 28 },
        { x: 550, y: 1000, size: 35, unvanY: 1045, unvanSize: 28 },
        { x: 900, y: 1000, size: 35, unvanY: 1045, unvanSize: 28 },
        { x: 1250, y: 1000, size: 35, unvanY: 1045, unvanSize: 28 },
        { x: 200, y: 1500, size: 35, unvanY: 1545, unvanSize: 28 },
        { x: 550, y: 1500, size: 35, unvanY: 1545, unvanSize: 28 },
        { x: 900, y: 1500, size: 35, unvanY: 1545, unvanSize: 28 },
        { x: 1250, y: 1500, size: 35, unvanY: 1545, unvanSize: 28 },
        { x: 200, y: 2000, size: 35, unvanY: 2045, unvanSize: 28 },
        { x: 550, y: 2000, size: 35, unvanY: 2045, unvanSize: 28 },
        { x: 900, y: 2000, size: 35, unvanY: 2045, unvanSize: 28 },
        { x: 1250, y: 2000, size: 35, unvanY: 2045, unvanSize: 28 }
      ],
      adres: { x: 130, y: 2360, size: 32 },
      tarih: { x: 1140, y: 2360, size: 45 },
      saat: { x: 1190, y: 2430, size: 45 },
      gun: { x: 1170, y: 2450, size: 45 }
    }
  },
  "Günübirlik Akademi 16 Kişilik": {
    template: "Günübirlik Akademi.png",
    persons: [
      { top: 580, left: 50, width: 280, height: 350, rankIcon: { top: 830, left: 30, width: 90 } },
      { top: 580, left: 390, width: 280, height: 350, rankIcon: { top: 830, left: 370, width: 90 } },
      { top: 580, left: 730, width: 280, height: 350, rankIcon: { top: 830, left: 710, width: 90 } },
      { top: 580, left: 1070, width: 280, height: 350, rankIcon: { top: 830, left: 1050, width: 90 } },
      { top: 1000, left: 50, width: 280, height: 350, rankIcon: { top: 1260, left: 20, width: 90 } },
      { top: 1000, left: 390, width: 280, height: 350, rankIcon: { top: 1260, left: 360, width: 90 } },
      { top: 1000, left: 730, width: 280, height: 350, rankIcon: { top: 1260, left: 700, width: 90 } },
      { top: 1000, left: 1070, width: 280, height: 350, rankIcon: { top: 1260, left: 1040, width: 90 } },
      { top: 1420, left: 50, width: 280, height: 350, rankIcon: { top: 1680, left: 20, width: 90 } },
      { top: 1420, left: 390, width: 280, height: 350, rankIcon: { top: 1680, left: 360, width: 90 } },
      { top: 1420, left: 730, width: 280, height: 350, rankIcon: { top: 1680, left: 700, width: 90 } },
      { top: 1420, left: 1070, width: 280, height: 350, rankIcon: { top: 1680, left: 1040, width: 90 } },
      { top: 1840, left: 50, width: 280, height: 350, rankIcon: { top: 2100, left: 20, width: 90 } },
      { top: 1840, left: 390, width: 280, height: 350, rankIcon: { top: 2100, left: 360, width: 90 } },
      { top: 1840, left: 730, width: 280, height: 350, rankIcon: { top: 2100, left: 700, width: 90 } },
      { top: 1840, left: 1070, width: 280, height: 350, rankIcon: { top: 2100, left: 1040, width: 90 } }
    ],
    texts: {
      baslik: { x: 960, y: 425, size: 70 },
      altBaslik: { x: 960, y: 495, size: 50 },
      names: [
        { x: 190, y: 950, size: 30, unvanY: 990, unvanSize: 25 },
        { x: 530, y: 950, size: 30, unvanY: 990, unvanSize: 25 },
        { x: 870, y: 950, size: 30, unvanY: 990, unvanSize: 25 },
        { x: 1210, y: 950, size: 30, unvanY: 990, unvanSize: 25 },
        { x: 190, y: 1370, size: 30, unvanY: 1410, unvanSize: 25 },
        { x: 530, y: 1370, size: 30, unvanY: 1410, unvanSize: 25 },
        { x: 870, y: 1370, size: 30, unvanY: 1410, unvanSize: 25 },
        { x: 1210, y: 1370, size: 30, unvanY: 1410, unvanSize: 25 },
        { x: 190, y: 1790, size: 30, unvanY: 1830, unvanSize: 25 },
        { x: 530, y: 1790, size: 30, unvanY: 1830, unvanSize: 25 },
        { x: 870, y: 1790, size: 30, unvanY: 1830, unvanSize: 25 },
        { x: 1210, y: 1790, size: 30, unvanY: 1830, unvanSize: 25 },
        { x: 190, y: 2210, size: 30, unvanY: 2250, unvanSize: 25 },
        { x: 530, y: 2210, size: 30, unvanY: 2250, unvanSize: 25 },
        { x: 870, y: 2210, size: 30, unvanY: 2250, unvanSize: 25 },
        { x: 1210, y: 2210, size: 30, unvanY: 2250, unvanSize: 25 }
      ],
      adres: { x: 130, y: 2360, size: 32 },
      tarih: { x: 1140, y: 2360, size: 45 },
      saat: { x: 1190, y: 2430, size: 45 },
      gun: { x: 1170, y: 2450, size: 45 }
    }
  }
};
